<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                Merchant
            </template>
            <template v-slot:pageDetail>
                List
            </template>
            <template v-slot:pageDescription>
               
                <br>
               
            </template>
        </o-bread-crumb>
        <div v-if="validation">
            <div class="alert alert-danger mt-1" role="alert">
                {{ validation }}
            </div>
        </div>
        <div v-if="thisComponentShow" class="card text-center">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">
                            <a class="nav-link text-dark fs-4" href="#">List of Merchants</a>
                        </div>
                    </li>
                    <li class="nav-item btn btn-primary btn-sm" v-if="write">
                        <router-link :to="{ name: 'MerchantForm' }" class="nav-link text-white">Add new merchant
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading"></div>
                <div class="spinner" v-if='page.isLoading'></div>
                <div class="" v-if="page.output">
                    <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                        <li class="nav-item">
                            <div class="d-flex d-inline-block">                                
                                <o-search :searchOptions="searchOptions" @submit="search" @clear="clearSearch"></o-search>
                            </div>
                        </li>
                        <li id="importBut" class="nav-item btn btn-primary btn-sm" v-if="write">
                            <button class="nav-link text-white" @click="showModal">Import</button>
                        </li>
                        <li class="nav-item btn btn-primary btn-sm">
                            <button class="reload nav-link text-white" @click.prevent="load_state()">&#x21bb;</button>
                        </li>
                    </ul>
                    <o-table style="text-align:left;" class="table-hover">
                        <thead>
                            <tr>
                                <td class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                    {{ field }}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in merchants" :key="index">
                                <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <div>{{ item.id.slice(0, 9) + '...' }}</div>
                                    </div>
                                </td>
                                <td>{{ item.code }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.business_profile.address }}</td>
                                <td class="ml-3">
                                    <div class="d-flex">
                                        <div class="me-1">
                                            <button class="btn btn-sm btn-info rounded-pill text-white" v-if="write">
                                                <router-link class="text-white" :to="{ name: 'MerchantEdit', params: { id: item.id } }">Edit
                                                </router-link>
                                            </button>
                                        </div>
                                        <div>
                                            <button class="btn btn-sm btn-danger rounded-pill text-white" v-if="write">
                                                <a class="text-white" href="#" @click.prevent="promptDelete(item.id, item.name)">Delete
                                                </a>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="merchants.length === 0">
                                <td colspan="7" class="text-center">No merchants available</td>
                            </tr>
                        </tbody>
                    </o-table>
                </div>
            </div>
            <div class="container mt-5">
                <o-pagination :page="meta.page"  :total="meta.total" @callback="navPage"/>
            </div>
        </div>
        <import-merchant
            v-if="isModalVisible"
            @saveDetail="handleImport" 
            @closeModal="closeModal"
        ></import-merchant>

        <o-warning-box
            v-if="isWarningVisible"
            title="Delete Merchant"
            :item-name="merchantToDeleteName"
            warning-message="This action will soft-delete the merchant to keep historical transaction data safe."
            confirm-text="Delete"
            :is-loading="page.isLoading"
            @confirm="handleForceDelete"
            @cancel="hideWarning"
        />
    </div>
    <br>
</template>

<script>
import store from '@/store/'
import { mapState } from 'vuex'
import { OTable, OPagination, OBreadCrumb, OSearch, OWarningBox } from '@/components/OmnihControl'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ImportMerchant from './merchant/ImportMerchant.vue';

export default {
    setup() {
        const route = useRoute();
        const router = useRouter();
        let meta = computed(() => store.state.Merchant.meta)

        let page = reactive({
            isLoading: false,
            output: false,
            component: 'merchant'
        });

        const selfLoaded = ref(store.state.Auth.selfLoaded);

        watch(
            () => store.state.Auth.selfLoaded,
            (newVal) => {
                if (newVal) {
                    selfLoaded.value = newVal;
                    load_state();
                }
            }
        );

        onMounted(() => {
            if (selfLoaded.value) {
                load_state();
            }

            // Check if redirected from create merchant page
            if (route.query.newMerchant === 'true') {
                store.dispatch('Merchant/read').then(() => {
                    const lastPage = meta.value.total;
                    if (lastPage > 1 && meta.value.page !== lastPage) {
                        const newMeta = { ...meta.value, page: lastPage };
                        store.commit('Merchant/switch_page', { meta: newMeta });
                        store.dispatch('Merchant/read');
                    }
                    router.replace({ name: 'Merchant' });
                });
            }
        });

        let fields = ref([
            'No',
            'Id',
            'Code',
            'Name',
            'Address',
            'Action'
        ]);
        let isModalVisible = ref(false);
        let uploadedFile = ref(null);
        let isWarningVisible = ref(false);
        let merchantToDeleteId = ref(null);
        let merchantToDeleteName = ref('');

        const validation = ref('');

        const merchantSearch = ref([]);

        const selectMerchant = ref();

        const searchBy = reactive({
            selected: "code",
            criteria: ""
        })

        const searchOptions = reactive([
            { value: 'code', text: 'code' },
            { value: 'name', text: 'name' },
        ])

        const thisComponentShow = ref(true);

        const write = ref(false);

        function load_state() {
            page.isLoading = true;

            store.dispatch('Auth/getBusinessProfile').then(businessProfile => {

                const filter = {};

                if (businessProfile.branch_id) {
                    filter.branch_id = businessProfile.branch_id;
                }

                store.commit('Merchant/add_filter', { filter });

                store.dispatch('Merchant/read')
                .catch((err) => {
                    console.log(err);
                    validation.value = err.response.data.message;
                    thisComponentShow.value = false;
                })
                .finally(() => {
                    page.isLoading = false
                    page.output = true
                });

                if (store.state.Auth.currUser.level === 'root') {
                    write.value = true;
                } else {
                    const userModules = store.state.Auth.userInfo.modules;

                    if (userModules) {
                        const matchingModule = userModules.find(module => module.module_name === page.component);
                        write.value = matchingModule ? matchingModule.write : false;
                    } else {
                        console.error('userModules is undefined');
                        write.value = false;
                    }
                }
            });
        }

        function showModal() {
            isModalVisible.value = true;
            uploadedFile.value = null;
        }

        function closeModal() {
            isModalVisible.value = false;
        }

        function handleImport(formData) {
            validation.value = '';
            store.dispatch('Auth/getBusinessProfile')
                .then(businessProfile => {
                    const fileData = Array.from(formData.entries()).find(([key]) => key === 'file');
                    const fileName = fileData[1].name;
                    formData.append('file', fileName);
                    formData.append('branch_id', businessProfile.branch_id);

                    store.dispatch('Merchant/import', { data: formData })
                        .then((response) => {
                            if (response) {
                                validation.value = "Import Merchant Successfully";
                            }
                            load_state();
                        })
                        .catch((error) => {
                            console.error('Import failed:', error);
                            console.log('error checking', error, error.response, error.response.data.error);
                            if (error.response && error.response.data && error.response.status !== 403 && Object.keys(error.response.data.error).length === 0) {
                                validation.value = "Don't match for file xls or csv merchants";
                            } else if (error.response && error.response.status === 403) {
                                validation.value = error.response.data.message;
                            }
                            throw error.response.data.error;
                        });
                })
                .catch(error => {
                    console.error('Failed to fetch business profile:', error);
                });
        }

        function onFileChange(event) {
            uploadedFile.value = event.target.files[0];
        }

        function promptDelete(id, name) {
            merchantToDeleteId.value = id;
            merchantToDeleteName.value = name;
            isWarningVisible.value = true;
        }

        function hideWarning() {
            isWarningVisible.value = false;
            merchantToDeleteId.value = null;
            merchantToDeleteName.value = '';
        }

        function handleForceDelete() {
            page.isLoading = true;

            store.dispatch('Merchant/delete', merchantToDeleteId.value)
                .then(() => {
                    load_state()
                    hideWarning()
                }).catch((err) => {
                    console.log(err);
                    validation.value = err.message || err;
                    hideWarning()
                }).finally(() => {
                    page.isLoading = false;
                });
        }

        function navPage(page) {
            const _meta = { ...meta.value, page }

            console.log({ page });
            console.log({ _meta });
            store.commit('Merchant/switch_page', { meta: _meta })
            load_state()
        }

        function search(searchBy) {
            const { selected, criteria } = searchBy;

            if (selected && criteria) {
                let search = {};
                search[selected] = criteria;

                store.commit('Merchant/set_search', { search });
                store.dispatch('Merchant/read').then(() => { });
            }

        }

        function clearSearch() {
            store.commit('Merchant/clear_search');
            store.dispatch('Merchant/read').then(() => { });
        }

        return {
            page,
            isWarningVisible,
            merchantToDeleteName,
            promptDelete,
            hideWarning,
            handleForceDelete,
            isModalVisible,
            showModal,
            closeModal,
            handleImport,
            load_state,
            fields,
            meta,
            navPage,
            merchantSearch,
            selectMerchant,
            searchBy,
            searchOptions,
            search,
            clearSearch,
            onFileChange,
            validation,
            thisComponentShow,
            write,
            selfLoaded
        }
    },
    computed: {
        ...mapState({
            merchants: state => state.Merchant.merchants,
            searchBy: state => state.OSearch
        }),
    },
    components: {
        OTable,
        OPagination,
        OBreadCrumb,
        OSearch,
        ImportMerchant,
        OWarningBox
    }
}
</script>

<style scoped>
.form-group {
    width: 250px;
    text-align: left;
    padding-left: 16px;
}
#importBut {
    position: absolute;
    right: 130px;
}
</style>